module.exports = __webpack_public_path__ + "img/G31_G41.d401abbf.png";